import { ATSConnectHiringRequestCreateReferenceContactIds } from 'data-testids/ATS';
import { ReferenceHeaderProps } from 'features/Connect/features/ConnectATSIntegration/types/referenceTypes';
import { TemplateSelectionFormContainer } from '../../../../styles/scorecardStyles';
import { Typography } from '@mui/material';

export const ReferenceHeader: React.FC<ReferenceHeaderProps> = ({ candidateName }) => {
  return (
    <TemplateSelectionFormContainer>
      <Typography
        variant="h3"
        data-testid={ATSConnectHiringRequestCreateReferenceContactIds.NEW_REFERENCE_CHECK_FOR_TITLE}
        sx={{ lineHeight: 2.2 }}
      >
        New reference check for {candidateName}
      </Typography>
    </TemplateSelectionFormContainer>
  );
};
